
import { defineComponent, PropType } from 'vue'
import Label from '@/components/AtomLabel.vue'
import Field from '@/components/AtomField.vue'
import Input from '@/components/AtomInput.vue'

export default defineComponent({
  emits: ['onChange'],
  components: {
    Label,
    Field,
    Input
  },
  props: {
    name: String as PropType<string>,
    value: String as PropType<string>,
    id: String as PropType<string>,
    label: String as PropType<string>
  },
  methods: {
    onChange (value:string) {
      this.$emit('onChange', value)
    }
  }
})
